import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = "Checkmate Payroll is a private software provider. We are not affiliated with, "
  + "endorsed by, or representing any government entity. All tax and payroll logic is based on "
  + "publicly available IRS and state documentation.";

/**
 * High-visibility non-affiliation band. Sits above all other footer content on
 * every page — marketing, legal and the signed-in app — and links to the full
 * disclaimer. Text is served by the backend so it matches the PDFs verbatim.
 */
export default function DisclaimerBand({ dark = false }) {
  const [text, setText] = useState(FALLBACK);

  useEffect(() => {
    fetch(`${API}/compliance/disclosures`)
      .then((r) => r.json())
      .then((d) => d?.disclaimer && setText(d.disclaimer))
      .catch(() => {});
  }, []);

  return (
    <div
      data-testid="footer-disclaimer-band"
      className={`border-b-2 ${dark ? "border-white/30 bg-ink" : "border-ink bg-ink"} text-white px-6 py-5`}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-start gap-3">
        <ShieldAlert className="w-5 h-5 shrink-0 mt-0.5" aria-hidden="true" />
        <div>
          <p className="font-mono text-xs sm:text-sm font-bold leading-relaxed text-white"
             data-testid="footer-disclaimer-text">
            {text}
          </p>
          <Link to="/legal/disclaimer" data-testid="footer-disclaimer-link"
                className="inline-block mt-2 font-mono text-[11px] uppercase tracking-widest underline hover:no-underline">
            Read the full disclaimer →
          </Link>
        </div>
      </div>
    </div>
  );
}
